<template>
  <div>
    <div :title="title" visible.sync="dialogVisible" v-if="dialogVisible" width="50%">
      <div style="padding: 20px">
        <div>
          <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <el-form-item label="清晰度" prop="videoType" class="el-select-form">
              <el-select v-model="form.videoType" @change="change" clearable placeholder="请选择清晰度"
                :popper-append-to-body="false">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="上传文件" prop="resourcesPath">
              <div>
                <el-upload-e :limit="1" :dir="ossConstant.dir.courseware" @onBefore="uploadBefore" :fileList="fileList"
                  @onSuccess="uploadSuccess" :accept="'.mp4'"></el-upload-e>
                <div class="el-upload__tip" slot="tip">只能上传.mp4文件</div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirm">确 定</el-button>
          <el-button @click="dialogVisibleFn(false)">取消</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import elUploadE from "@/components/common/oss/ossUploadMultiple";
import $ossConstant from "@/components/common/oss/ossConstant";
import $const from "@/common/constant";
export default {
  components: { elUploadE },
  data() {
    return {
      fileList: [],
      $const: $const,
      ossConstant: $ossConstant,
      title: "上传清晰度",
      dialogVisible: false,
      options: [{
        value: '1',
        label: '流畅'
      }, {
        value: '2',
        label: '标清'
      }, {
        value: '3',
        label: '高清'
      }, {
        value: '4',
        label: '超清'
      }],
      form: {
        definitionVideoId: undefined,
        fileName: undefined,
        fileSize: undefined,
        fileType: undefined,
        videoType: undefined,
        typeName: undefined,
        resourcesPath: undefined,
        trainingResourcesDataId: undefined,
        trainingResourcesId: undefined,
        accessPath: undefined,
        duration: 0
      },
      rules: {
        videoType: [
          { required: true, message: '请选择清晰类型', trigger: 'change' }
        ],
        resourcesPath: [
          { required: true, message: '请上传文件', trigger: 'blur' },
        ]
      }

    }
  },
  methods: {
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.dialogVisible = false;
          this.dialogVisibleFn(false)
          this.$emit("confirm", this.form)
        }
      })
    },
    dialogVisibleFn(flag) {
      this.dialogVisible = flag
      // this.$emit("isShowDefinition", this.dialogVisible)
    },
    change(val) {
      let result = this.options.find((item) => {  
        return item.value == val;
      });
      this.form.videoType = result.value;
      this.form.typeName = result.label;

      console.log("form--", this.form)
    },
    reset() {
      this.form = {
        definitionVideoId: undefined,
        fileName: undefined,
        fileSize: undefined,
        fileType: undefined,
        videoType: undefined,
        typeName: undefined,
        resourcesPath: undefined,
        trainingResourcesDataId: undefined,
        trainingResourcesId: undefined,
        accessPath: undefined,
        duration: 0
      }
    },
    show(data) {
      this.reset();
      this.fileList = []
      this.dialogVisible = true;
    },
    /**
     * 获取时长度
     */
    getTimes(file) {
      let content = file;
      let url = URL.createObjectURL(content);
      let audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata", (_event) => {
        let num = Math.floor(audioElement.duration / 60) > 0 ? Math.floor(audioElement.duration / 60) : 1;
        this.form.duration = num
      });
    },
    /**
     * 上传之前
     **/
    uploadBefore(file) {
      let fileType = file.name.split('.').pop().toLowerCase();
      if (fileType == 'mp4') {
        this.getTimes(file);
      }
    },
    /**
     * 上传文件成功回调
     */
    uploadSuccess(e, data, file) {
      let size = Math.ceil(file.size / 1024 / 1024);
      this.form.fileName = file.name;
      this.form.fileType = file.raw.type;
      this.form.fileSize = size;
      this.form.resourcesPath = data.name;
      this.form.accessPath = data.url;
    },
  }
}
</script>


<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  border-top: 1px solid #dbdada;
  text-align: right;
  padding: 10px 20px !important;
}

.el-select-form {
  /deep/ .el-select-dropdown {
    position: absolute !important;
    top: 33px !important;
    left: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/definition/definitionVideoAdd.vue